<i18n>
{
"en": {
  "WIOT": "WIOT",
  "STUDENT": "Student",
  "ADD": "Add",
  "DASHBOARD": "Dashboard",
  "SCHOOL": "School",
  "SCHOOLINFO": "School Info",
  "ATTENDANCE": "Attendance",
  "LOGS": "Logs",
  "ALERT": "Alert",
  "STUDENTS": "Students",
  "GUARDIANS": "Guardians",
  "TRANSPORTATION": "Transportation",
  "BUSES": "Buses",
  "DRIVERS": "Drivers",
  "ROUTES": "Routes",
  "ABSENCES": "Absences",
  "ABSENCE": "Absence",
  "GATES": "Gates",
  "REPORTS": "Reports",
  "USERS": "Users",
  "USER": "User",
  "GUARDIAN": "Guardian",
  "DRIVER": "Driver",
  "SUPERVISORS": "Supervisors",
  "ADMIN": "Admin",
  "MYPROFILE": "My Profile",
  "SCHOOLSETTINGS": "School Settings",
  "LANGUAGES": "Languages",
  "ARABIC": "Arabic",
  "LOGOUT": "Logout",
  "NODATA": "No Data",
  "ROUTE": "Route",
  "ROLES": "Roles",
  "ROLE": "Role",
  "CANCEL": "Cancel",
  "CONFIRM": "Confirm",
  "PLEASEENTERYOURPASSWORD": "Please enter your password",
  "HASBEEN": " has been ",
  "CREATED": "created!",
  "CANCELLED": "cancelled!",
  "CLOSED": "closed!",
  "YOUHAVERECEIVEDANEWMESSAGE": "You have received a new message!.",
  "NEWINCIDENT": "New Incident",
  "NEWVIOLATION": "New Violation",
  "BUS": "Bus",
  "SUPERVISOR": "Supervisor",
  "TRIP": "Trip",
  "C": "°C",
  "INVALIDUSER": "Invalid user",
  "SUCCESS": "Session Extended",
  "DELAYED": "delayed!",
  "violation_video_loss": "Lost video signal",
  "violation_motion_detection": "Motion detected",
  "violation_blind": "Camera Blocked",
  "violation_storage": "Storage error @3 on disk @1",
  "violation_user_1": "Smoke detected",  
  "violation_user_2": "Airflow-Sensor",
  "violation_user_3": "Inner Temperature",
  "violation_user_4": "Inner Humidity",
  "violation_user_5": "Bus stalled",
  "violation_user_6": "User alarm 6",
  "violation_user_7": "User alarm 7",
  "violation_user_8": "User alarm 8",
  "violation_user_9": "User alarm 9",
  "violation_user_10": "User alarm 10",
  "violation_emergency": "Panic button pressed",
  "violation_low_speed": "Low speed alarm (@1 km/h)",
  "violation_high_speed": "High speed alarm (@1 km/h)",
  "violation_low_voltage": "Low voltage (@1 v)",
  "violation_acceleration": "Acceleration alarm @1",
  "violation_inspection_failed": "Red Button Not Pressed",
  "violation_firealarm_release": "Smoke detector off",
  "violation_stop_buttom_pressed": "Stop Button Pressed",
  "violation_stop_buttom_released": "Stop Button Released"
},
"ar": {
	"WIOT": "وايت",
	"STUDENT": "طالب",
	"ADD": "إضافة",
	"DASHBOARD": "لوحة القيادة",
	"SCHOOLINFO": "معلومات المدرسة",
	"SCHOOL": "المدرسة",
	"ATTENDANCE": "الحضور",
	"LOGS": "السجلات",
	"ALERT": "تحذير ",
	"STUDENTS": "الطلاب",
	"GUARDIANS": "أولياء اﻷمور",
	"TRANSPORTATION": "المواصلات",
	"BUSES": "الحافلات",
	"DRIVERS": "السائقين",
	"ROUTES": "خطوط السير",
	"ABSENCES": "الغياب",
	"ABSENCE": "غياب",
	"GATES": "البوابات",
	"REPORTS": "التقارير",
	"USERS": "المستخدمين",
	"USER": "المستخدم",
	"GUARDIAN": "ولي الامر",
	"DRIVER": "السائق",
	"SUPERVISORS": "المشرفات",
	"ADMIN": "الإدارة",
	"MYPROFILE": "ملفي الشخصي",
	"SCHOOLSETTINGS": "اعدادات المدرسة",
	"LANGUAGES": "اللغات",
	"(ARABIC)": "(عربي)",
	"ENGLISH": "الإنجليزية",
	"LOGOUT": "الخروج",
	"NODATA": "لا توجد بيانات",
	"ROUTE": "الطريق",
	"ROLES": "أدوار المستخدمين",
	"ROLE": "دور",
	"CANCEL": "إلغاء",
	"CONFIRM": "تاكيد ",
	"PLEASEENTERYOURPASSWORD": " من فضلك أدخل رقمك السري",
	"HASBEEN": " ",
	"CREATED": "انجزت!",
	"CANCELLED": "ألغيت!",
	"CLOSED": "أغلقت!",
	"YOUHAVERECEIVEDANEWMESSAGE": "لقد تلقيت رسالة جديدة!",
	"NEWINCIDENT": "حادث جديد",
	"NEWVIOLATION": "انتهاك جديد",
  "BUS": "الحافلة",
  "SUPERVISOR": "المشرفة",
  "TRIP": "رحلة",
  "C": "°س",
  "INVALIDUSER": "المستخدم غير صالح",
  "SUCCESS": " تم تمديد الدورة",
  "DELAYED": "مؤجل!",
  "violation_video_loss": "فقدت إشارة الفيديو",
  "violation_motion_detection": "تم اكتشاف حركة",
  "violation_blind": "عمياء {POS } الكاميرا",
  "violation_storage": "خطأ في التخزين @ 3 على القرص @ 1",
  "violation_user_1": "تم الكشف عن الدخان",  
  "violation_user_2": "  استشعار تدفق الهواء ",
  "violation_user_3": "درجة الحرارة الداخلية",
  "violation_user_4": "الرطوبة الداخلية",
  "violation_user_5": "توقفت الحافلة ",
  "violation_user_6": " 6 تنبيه المستخدم ",
  "violation_user_7": "7 تنبيه المستخدم",
  "violation_user_8": "8 تنبيه المستخدم",
  "violation_user_9": " 9 تنبيه المستخدم",
  "violation_user_10": " 10 تنبيه المستخدم",
  "violation_emergency": "تم الضغط على زر الهلع",
  "violation_low_speed":  "إنذار انخفاض السرعة (@ 1 كم / ساعة)",
  "violation_high_speed": "إنذار ارتفاع السرعة (@ 1 كم / ساعة)",
  "violation_low_voltage": "V انخفاض الجهد (@ 1)",
  "violation_acceleration": "1 @ تنبيه السرعة",
  "violation_header": "اتفاقية مستوى الخدمة الانتهاكات والإنذارات",
  "violation_inspection_failed": "زر أحمر لم تضغط",
  "violation_firealarm_release": "Smoke detector off",
  "violation_stop_buttom_pressed": "Stop Button Pressed",
  "violation_stop_buttom_released": "Stop Button Released"
}
}
</i18n>
<template>
  <div id="app" class="el-row">
    <header ref="header">

      <el-row  class="dark">
        <el-col :span="10">
          <ul mode="horizontal" id="day-info" style="padding:0 5px;">
            <li style="min-width:200px"><span v-html="datenow"></span></li>
            <li v-if="temp"><i class="fa fa-sun-o"></i> {{temp}} {{$t('C')}}</li>
          </ul>
        </el-col>
        <el-col :span="4" align="center" style="padding:15px 0">
         <span class="navbar-brand" v-if="$route.name!='Login' && $route.name!='ResetPassword'">{{school_name}}</span>
        </el-col>
        <el-col :span="10">
          <ul  class="badges" v-if="$route.name!='Login' && $route.name!='ResetPassword'" >
            <li class="badge_icon" style="padding: 10px 0;" v-if="hide_sidebar">
              <el-badge :value="active_messages()" class="item">
                <el-button type="text"  @click="handleCommand('message')" ><i class="fa fa-envelope fa-2x"></i></el-button>
              </el-badge>
              <el-badge :value="active_incidents()" class="item">
                <el-button type="text"  @click="handleCommand('incident')" ><i class="fa fa-exclamation-triangle fa-2x"></i></el-button>
              </el-badge>

              <el-badge v-if="wiot_box==1" :value="active_violations()" class="item">
                <el-button type="text"  @click="handleCommand('violation')" ><i class="fa fa-tachometer fa-2x"></i></el-button>
              </el-badge>
              <el-badge :value="active_trips()" class="item">
                <el-button type="text"  @click="handleCommand('trip')" ><i class="fa fa-bus fa-2x"></i></el-button>
              </el-badge>
 
            </li>

            <li class="entry" v-if="allowed_add.length!=0">


              <el-dropdown @command="handleCommand"  v-if="hide_sidebar">
      <span class="el-dropdown-link">
        <i class="fa fa-plus"></i>  {{$t('ADD')}}
        </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :key="index" v-for="(item, index) in allowed_add" :divided="item.divide" :command="item.command">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>

            <li class="profile">


              <el-dropdown   @command="handleCommand">
              <span class="el-dropdown-link">
              <img style="width: 30px" :src="getAsset(profile_photo, 'user')" :alt="full_name" class="img-circle">
              <span class="profile-name"><i class="fa fa-angle-down"></i> {{full_name}} </span>
              </span>
 
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="hide_sidebar" command="profile">{{$t('MYPROFILE')}}</el-dropdown-item>
                  <el-dropdown-item v-if="isAllowed('save', 'school/configuration') && hide_sidebar" command="school">{{$t('SCHOOLSETTINGS')}}</el-dropdown-item>
                  <el-dropdown-item v-if="hide_sidebar" disabled divided>{{$t('LANGUAGES')}}</el-dropdown-item>
                  <el-dropdown-item command="en" v-if="lang!='en'">{{$t('ENGLISH')}}</el-dropdown-item>
                  <el-dropdown-item command="ar" v-if="lang!='ar'">{{$t('ARABIC')}}</el-dropdown-item>
                  <el-dropdown-item divided command="logout">{{$t('LOGOUT')}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </li>
          </ul>


        </el-col>
      </el-row>

      </header>
    <el-row class="container">
      <el-col :span="3" v-show="hide_sidebar" class="menu">
        <div id="logo" ref="logo">
       <el-button type="text"  @click="$router.push({path:'/'})" > <img :src="require('./assets/img/logo.png')"/>
       <br/>
       <h2>{{$t('WIOT')}} </h2>
        </el-button>
        </div>
 
        <el-scrollbar v-if="hide_sidebar"  :viewStyle="{ height: sideBarHeight + 'px' }" ref="menuScroll" class="my-scrollbar">


        <div>
        <el-menu  @open="openMenu"  mode="vertical" :unique-opened="true" :router="true">
          <div :key="key" v-for="(navigation, key) in navigations">
          <el-submenu v-if="navigation.menu.length != 0" v-bind:class="[activeIndex==key && navigation.target != null ? 'activated is-opened' : (navigation.target != null ? 'hide-arrow' : '')]" :index="key.toString()">
            <template slot="title"><i :class="navigation.icon"></i> {{navigation.name}}</template>
            <el-menu-item @click="subMenuActive= key+''+_key" v-bind:class="[subMenuActive== key+''+_key ? 'sub-active' : '']"  :index="menu.target" :key="_key" v-for="(menu, _key) in navigation.menu">{{menu.name}}</el-menu-item>
          </el-submenu>
          <el-menu-item v-else @click="subMenuActive= key.toString()" v-bind:class="[subMenuActive== key ? 'sub-active' : '']"  :index="navigation.target" >
            <template slot="title"><i :class="navigation.icon"></i> {{navigation.name}}</template>
          </el-menu-item>
          </div>
        </el-menu>
     
 </div>
        </el-scrollbar>
     
      </el-col>
      <el-col :span="(hide_sidebar)  ? 21 : 24" :offset="(hide_sidebar) ? 3 : 0">
        <router-view class="content"></router-view>
      </el-col>
    </el-row>
    <el-incident-dialog :incident="incident" :visible.sync="incidentBox"></el-incident-dialog>
    <el-absence-dialog :data="absence" :search="true" :visible.sync="absenceBox" :server-check="true"></el-absence-dialog>  
    <el-auth-dialog @authBack="sessionExtended" :sessionExpiration="session_expiration" :visible.sync="sessionDialog" :itSelf="true" :timer="timer"></el-auth-dialog>  
  </div>
</template>

<script>
import Vue from 'vue'
import IncidentDialog from '@/components/dialogs/Incident'
import AbsenceDialog from '@/components/dialogs/Absence'
import AuthDialog from '@/components/dialogs/Auth'
import locale from 'element-ui/lib/locale'
import NoImage from './assets/img/no-photo.jpg'
import NoLogo from './assets/img/no-school.png'
import axios from 'axios'
import { EventBus } from './event-bus.js'
let userData = null
Vue.mixin({
  data () {
    return {
      URL: Vue.END_POINT,
      BASEURL: Vue.BASE_URL,
      AWS_ASSETS: Vue.AWS_ASSETS,
      AWS_FOLDERS: Vue.AWS_FOLDERS,
      API_KEY: null,
      SCHOOL_ID: null,
      USER_LEVEL: null
    }
  },
  mounted () {
    if (localStorage.getItem('userData') === null) return
    this.API_KEY = localStorage.getItem('api_key')
    this.SCHOOL_ID = localStorage.getItem('school_id')
    this.USER_LEVEL = parseInt(localStorage.getItem('user_level'))
  },
  methods: {
    isAllowed (action, path) {
      if ((this.USER_LEVEL === 1 && !isNaN(this.USER_LEVEL)) || this.$permissions.length === 0) return true
      if (this.$route.params.id !== undefined && this.$route.params.id === localStorage.getItem('user_id') && this.$route.path.split('/')[2] === 'user') return true
      if (path !== undefined) {
        let _path = path.split('/')
        if (this.$permissions[_path[0]] !== undefined && this.$permissions[_path[0]][_path[1]] !== undefined) return this.$permissions[_path[0]][_path[1]].includes(action)
        return false
      }
      return (this.$route.meta.permissons !== undefined && this.$route.meta.permissons.includes(action))
    },
    currentLang () {
      return localStorage.getItem('lang')
    },
    dateFormat (date) {
      return new Date(date.replace(/-/g, '/'))
    },
    getAsset (image, folder, logo = false) {
      if (folder === undefined) folder = this.$route.path.split('/')[2]
      let school = localStorage.getItem('school_id')
      let path = this.AWS_ASSETS + school + this.AWS_FOLDERS[folder]
      if (image === undefined || image === null || image === 'no-photo.jpg') return logo ? NoLogo : NoImage
      return path + image
    },
    nameValidation (rule, value, callback) {
      let arregex = /^[a-zA-Z\s-]*$/
      let message = this.$t('ISNOTAVALIDFORMAT')
      if (rule.field.split('_')[1] === 'AR') {
        message = this.$t('ISNOTAVALIDARABICFORMAT')
        arregex = /^[\u0621-\u064A\u0660-\u0669\s-]*$/
      }
      if (value && !arregex.test(value)) callback(message)
      callback()
    },
    sessionExtended (data) {
      if (!data.error) {
        this.$message({type: 'success', message: this.$t(data.message)})
      }
    },
    setBodyAttributes (docBody) {
      docBody.setAttribute('id', 'rtl')
      docBody.setAttribute('dir', 'rtl')
    },
    removeBodyAttributes (docBody) {
      docBody.removeAttribute('id')
      docBody.setAttribute('dir', 'ltr')
    },
    switchLanguage () {
      let translator = this.$i18n
      let language = localStorage.getItem('lang')
      let localeLang = require('element-ui/lib/locale/lang/' + language)
      let docBody = document.getElementsByTagName('body')[0]
      EventBus.$on('langEmit', lang => {
        localeLang = require('element-ui/lib/locale/lang/' + lang)
        translator.locale = lang
        this.school_name = lang === 'en' ? userData.school_name : userData.school_name_ar
        this.full_name = lang === 'en' ? userData.full_name : userData.full_name_ar
        locale.use(localeLang.default)
        if (typeof this.side_bar_menu === 'function') {
          this.sideBarSize()
          this.side_bar_menu()
          this.allowed_create()
        }
        if (lang === 'ar') return this.setBodyAttributes(docBody)
        if (docBody.hasAttribute('id')) this.removeBodyAttributes(docBody)
        this.lang = lang
      })
      let lang = localStorage.getItem('lang')
      translator.locale = lang
      locale.use(localeLang.default)
      this.lang = lang
      if (lang === 'ar') return this.setBodyAttributes(docBody)
      if (docBody.hasAttribute('id')) this.removeBodyAttributes(docBody)
    },
    _FullName (row) {
      let name = row.NameEN
      if (localStorage.getItem('lang') === 'ar') name = row.NameAR
      return name
    },
    alignDirection (align) {
      if (localStorage.getItem('lang') === 'en') return align
      return (align === 'left' ? 'right' : 'left')
    }
  }
})
export default {
  components: {'el-incident-dialog': IncidentDialog, 'el-absence-dialog': AbsenceDialog, 'el-auth-dialog': AuthDialog},
  name: 'app',
  data () {
    return {
      activeIndex: '0',
      subMenuActive: null,
      handleSelect: '',
      channel: null,
      privateChannel: null,
      active_nav: 0,
      school: null,
      sideBarHeight: 0,
      school_name: null,
      full_name: null,
      username: null,
      profile_photo: null,
      datenow: null,
      school_location: {},
      loggedin_id: null,
      incidentBox: false,
      incident: {},
      absence: {AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0},
      absenceBox: false,
      session_expiration: null,
      password: null,
      closeSession: null,
      sessionDialog: false,
      timer: '0',
      school_id: null,
      key: null,
      temp: null,
      lang: 'en',
      permissions: [],
      navigations: [],
      user_level: null,
      wiot_box: null,
      TIME: null,
      navigation_map: {},
      allowed_add: []
    }
  },
  computed: {
    hide_sidebar () {
      if (this.$route.name !== 'Login' && this.$route.name !== 'ResetPassword') return true
      return false
    }
  },
  onIdle () {
    console.log('idle mode detected')
  },
  onActive () {
    console.log('active mode detected')
  },
  mounted () {
    if (!localStorage.getItem('lang')) localStorage.setItem('lang', 'en')
    this.switchLanguage()
    this.clockAndDate()
    if (localStorage.getItem('userData') === null && this.$route.name === 'ResetPassword') return this.$router.push({name: 'ResetPassword', params: {id: this.$route.params.id}, query: {rh: this.$route.query.rh}})
    if (localStorage.getItem('userData') === null && this.$route.name !== 'login') return this.$router.push('login')
    if (this.$route.path === '/login' && Number.isInteger(this.session_expiration)) this.$router.push('/')
    this.sideBarSize()
    this.onLoading()
    this.side_bar_menu()
    this.allowed_create()
  },
  created () {
    if (localStorage.getItem('userData') !== null) {
      userData = JSON.parse(localStorage.getItem('userData'))
      this.loadUserData(userData)
    }
    EventBus.$on('userData', passedData => {
      userData = passedData
      localStorage.setItem('userData', JSON.stringify(userData))
      this.loadUserData(userData)
      this.switchLanguage()
      this.loggedIn()
    })
  },
  methods: {
    allowed_create () {
      let actions = [
        {
          name: this.$t('STUDENT'),
          command: 'student',
          module: 'school',
          divide: false
        },
        {
          name: this.$t('GUARDIAN'),
          command: 'guardian',
          module: 'school',
          divide: false
        },
        {
          name: this.$t('ABSENCE'),
          command: 'absence',
          module: 'attendance',
          divide: false
        },
        {
          name: this.$t('BUS'),
          command: 'bus',
          module: 'transportation',
          divide: true
        },
        {
          name: this.$t('DRIVER'),
          command: 'driver',
          module: 'transportation',
          divide: false
        },
        {
          name: this.$t('SUPERVISOR'),
          command: 'supervisor',
          module: 'transportation',
          divide: false
        },
        {
          name: this.$t('ROUTE'),
          command: 'route',
          module: 'transportation',
          divide: false
        },
        {
          name: this.$t('USER'),
          command: 'user',
          module: 'admin',
          divide: true
        }
      ]
      if (this.user_level === 1) return (this.allowed_add = actions)
      for (let item in actions) {
        let path = actions[item].module + '/' + actions[item].command
        if (this.isAllowed('save', path)) this.allowed_add.push(actions[item])
      }
      return this.allowed_add
    },
    loggedIn () {
      this.sideBarSize()
      this.onLoading()
      this.side_bar_menu()
      this.allowed_create()
    },
    active_trips () {
      return EventBus.trips.total
    },
    active_incidents () {
      return EventBus.incidents.total
    },
    active_messages () {
      return EventBus.messages.total
    },
    active_violations () {
      return EventBus.violations.total
    },
    sideBarSize () {
      this.$nextTick(function () {
        this.sideBarHeight = window.innerHeight - this.$refs.logo.offsetHeight - this.$refs.header.offsetHeight
        if (this.$refs.menuScroll === undefined) return
        this.$refs.menuScroll.update()
        if (this.lang === 'ar') {
          this.$refs.menuScroll.$refs.wrap.style.marginLeft = '-15px'
          this.$refs.menuScroll.$refs.wrap.style.marginRight = ''
        } else {
          this.$refs.menuScroll.$refs.wrap.style.marginRight = '-15px'
          this.$refs.menuScroll.$refs.wrap.style.marginLeft = ''
        }
      })
    },
    openMenu (index, keypath) {
      let navigation = this.navigations
      // if (this.activeIndex !== index) this.subMenuActive = null
      this.activeIndex = index
      this.sideBarSize()
      if (navigation[index].target === null) return
      this.$router.push(navigation[index].target)
    },
    side_bar_menu () {
      let navigation = [
        {
          name: this.$t('DASHBOARD'),
          target: '/',
          module: null,
          icon: 'fa fa-dashboard',
          menu: []
        },
        {
          name: this.$t('SCHOOL'),
          target: null,
          module: 'school',
          icon: 'fa fa-university',
          menu: [
            {name: this.$t('STUDENTS'), target: '/school/student', controller: 'student'},
            {name: this.$t('GUARDIANS'), target: '/school/guardian', controller: 'guardian'},
            {name: this.$t('SCHOOLINFO'), target: '/school/configuration', controller: 'configuration'}
          ]
        },
        {
          name: this.$t('TRANSPORTATION'),
          target: null,
          module: 'transportation',
          icon: 'fa fa-road',
          menu: [
            {name: this.$t('BUSES'), target: '/transportation/bus', controller: 'bus'},
            {name: this.$t('DRIVERS'), target: '/transportation/driver', controller: 'driver'},
            {name: this.$t('SUPERVISORS'), target: '/transportation/supervisor', controller: 'supervisor'},
            {name: this.$t('ROUTES'), target: '/transportation/route', controller: 'route'}
          ]
        },
        {
          name: this.$t('ATTENDANCE'),
          target: null,
          module: 'attendance',
          icon: 'fa fa-list-alt',
          menu: [
            {name: this.$t('ABSENCES'), target: '/attendance/absence', controller: 'absence'}
          ]
        },
        {
          name: this.$t('REPORTS'),
          target: '/report',
          module: 'report',
          icon: 'fa fa-bar-chart',
          menu: []
        },
        {
          name: this.$t('ADMIN'),
          target: null,
          icon: 'fa fa-user',
          module: 'admin',
          menu: [
            {name: this.$t('USERS'), target: '/admin/user', controller: 'user'},
            {name: this.$t('ROLES'), target: '/admin/role', controller: 'role'},
            {name: this.$t('LOGS'), target: '/admin/log', controller: 'log'}
          ]
        }
      ]
      if (this.user_level === 1) return (this.navigations = navigation)
      let _navigation = []
      let i = 0
      let k = 0
      for (let item in navigation) {
        let module = navigation[item].module
        if (this.permissions[module] !== undefined || module === null) {
          _navigation[k] = Object.assign({}, navigation[item])
          _navigation[k].menu = []
          for (let _item in navigation[item].menu) {
            let controller = navigation[i].menu[_item].controller
            if (this.permissions[module][controller] !== undefined) {
              _navigation[k].menu.push(navigation[i].menu[_item])
            }
          }
          k++
        }
        i++
      }
      this.navigations = _navigation
    },
    onLoading () {
      if (localStorage.getItem('userData') === null) return
      this.weather()
      this.liveCounts()
      this.school = this.school_id
      if (this.school === null) return

      this.subscribeToMessage()
      this.subscribeToIncident()
      this.subscribeToAlert()
      this.subscribeToViolation()
      this.subscribeToTrip()
    },
    clockAndDate () {
      let direction = localStorage.getItem('lang') === 'en' ? 'ltr' : 'rtl'
      let textTimeF = ' [<span dir="' + direction + '">][<i class="fa fa-calendar-o"></i>] MMM.'
      let textTimeL = ' D, YYYY [</span>][<span  style="margin:0 10px;" dir="' + direction + '">][<i class="fa fa-clock-o"></i>] HH:mm:ss [</span>]'
      let localLocale = this.$moment()
      if (this.$route.path !== '/login' && isNaN(this.session_expiration)) return this.clearSessionData()
      this.datenow = localLocale.format(textTimeF) + this.$moment().format(textTimeL)
      setTimeout(this.clockAndDate, 1000)
      this.session_expiration = parseInt(localStorage.getItem('session_expiration'))
      let currentTime = this.$moment().unix()
      if ((this.session_expiration - currentTime) < 0) return this.clearSessionData()
      let time = this.session_expiration - currentTime
      let duration = this.$moment.duration(time * 1000)
      this.timer = this.$moment.utc(duration.asMilliseconds()).format('mm:ss')
      this.TIME = this.$moment().unix()
      if (this.session_expiration === null) return
      if (time === 1800 || time === 1000) this.sessionDialog = true
      if (time === 100) return this.handleCommand('logout')
    },
    weather () {
      let self = this
      let params = {key: '34c5088e6e7542daaba85722170506', q: this.school_location.Lat + ',' + this.school_location.Lng, lang: this.lang}
      axios.get('https://api.apixu.com/v1/forecast.json', {params: params}).then(function (response) {
        self.temp = response.data.current.temp_c
      }).catch(function (response) {})
    },
    loadUserData (userData) {
      let lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
      this.session_expiration = userData.session_expiration
      this.school_name = lang === 'en' ? userData.school_name : userData.school_name_ar
      this.full_name = lang === 'en' ? userData.full_name : userData.full_name_ar
      this.username = userData.username
      this.profile_photo = userData.profile_photo
      this.school_id = userData.school_id
      this.API_KEY = userData.key
      this.USER_LEVEL = userData.user_level
      this.school_location = userData.school_location
      this.loggedin_id = userData.user_id
      this.permissions = userData.permissions
      this.user_level = userData.user_level
      this.wiot_box = userData.wiot_box
      document.title = 'WIOT - ' + (lang === 'en' ? userData.school_name : userData.school_name_ar)
      localStorage.setItem('session_expiration', userData.session_expiration)
      localStorage.setItem('notification', userData.notification)
      localStorage.setItem('wiot_box', userData.wiot_box)
      localStorage.setItem('school_id', userData.school_id)
      localStorage.setItem('api_key', userData.key)
      localStorage.setItem('user_level', userData.user_level)
      localStorage.setItem('user_id', userData.user_id)
      localStorage.setItem('locale', JSON.stringify({'country': userData.school_location.country, 'timeZone': 'N/A'}))
    },
    liveCounts () {
      axios.all([this.latestIncidents(), this.latestMessages(), this.latestViolations(), this.latestTrips()]).then(axios.spread(function (incidents, messages, violations, trips) {
        EventBus.incidents.total = incidents.data
        EventBus.messages.total = messages.data
        EventBus.violations.total = violations.data
        EventBus.trips.total = trips.data
      }))
    },
    handleCommand (command) {
      if (command === undefined) return
      let path = null
      switch (command) {
        case 'logout':
          this.logout()
          break
        case 'en':
        case 'ar':
          this.lang = command
          localStorage.setItem('lang', command)
          EventBus.$emit('langEmit', command)
          path = this.$route.path
          break
        case 'student':
          path = '/school/student/create'
          break
        case 'guardian':
          path = '/school/guardian/create'
          break
        case 'absence':
          this.absenceBox = true
          path = this.$route.path
          break
        case 'bus':
          path = '/transportation/bus/create'
          break
        case 'driver':
          path = '/transportation/driver/create'
          break
        case 'supervisor':
          path = '/transportation/supervisor/create'
          break
        case 'route':
          path = '/transportation/route/create'
          break
        case 'user':
          path = '/admin/user/create'
          break
        case 'school':
          path = '/school/configuration'
          break
        case 'profile':
          path = '/admin/user/' + this.loggedin_id
          break
        case 'message':
        case 'incident':
        case 'violation':
        case 'trip':
          let c = command + 's'
          if (command !== 'trip') this.$set(EventBus.$data[c], 'total', 0)
          path = '/report/' + command
          break
        default:
      }
      if (path !== null) this.$router.push(path)
    },
    subscribeToMessage () {
      let self = this
      this.$channel.bind('message', (data) => {
        self.getMonitorInfo(data)
      })
    },
    subscribeToIncident () {
      let self = this
      this.$channel.bind('incident', (data) => {
        self.getIncidentInfo(data)
      })
    },
    subscribeToAlert () {
      this.$channel.bind('alert', (data) => {
        EventBus.$emit('alert', data)
      })
    },
    getIncidentInfo (data) {
      var self = this
      let _data = data
      this.$http.get('/incident/info?BusID=' + data.BusID + '&BusMonitorID=' + data.BusMonitorID + '').then(function (response) {
        _data.status = 'open'
        _data.statusColor = 2
        _data.IsSticky = false
        _data.bus = response.data.bus
        _data.monitor = response.data.supervisor
        if (EventBus.bus_numbers[data.BusID] !== undefined) EventBus.bus_numbers[data.BusID] = _data.bus.Label
        if (!EventBus.incidents.ids.includes(data.incident_id)) {
          EventBus.incidents.ids.push(parseInt(data.incident_id))
          EventBus.$emit('incident', _data)
          EventBus.incidents.total++
          self.newIncident(_data)
        }
      }).catch(function (response) {})
    },
    getMonitorInfo (data) {
      var self = this
      let _data = data
      this.$http.get('/supervisor/' + data.SenderID).then(function (response) {
        _data.monitor = response.data.person
        if (!EventBus.messages.ids.includes(data.MessageID)) {
          EventBus.messages.ids.push(parseInt(data.MessageID))
          EventBus.$emit('message', _data)
          EventBus.messages.total++
          self.newMessage(_data)
        }
      }).catch(function (response) {})
    },
    getBusInfo (data, type) {
      let _data = data
      let self = this
      if (EventBus.bus_numbers[data.BusID] !== undefined && type === 'violation') {
        _data.busNumber = EventBus.bus_numbers[data.BusID]
        return EventBus.$emit(type, _data)
      }
      this.$http.get('/bus/info?BusID=' + data.BusID).then(function (response) {
        _data.busNumber = response.data.Label
        EventBus.bus_numbers[data.BusID] = response.data.Label
        EventBus.$emit(type, _data)
        if (data.Db_Date !== null && data.Db_Date !== undefined) self.subscribeToBoarding(data.TripID)
      }).catch(function (response) {})
    },
    subscribeToBoarding (TripID) {
      this.$channel.bind('boarding-' + TripID, (boarding) => {
        EventBus.$emit('boarding', {TripID: TripID, data: boarding})
      })
    },
    subscribeToViolation () {
      let self = this
      this.$channel.bind('violation', (data) => {
        let ViolationID = parseInt(data.ViolationID)
        if (!EventBus.violations.ids.includes(ViolationID)) {
          EventBus.violations.ids.push(ViolationID)
          self.getBusInfo(data, 'violation')
          EventBus.violations.total++
          self.newViolation(data)
        }
      })
    },
    subscribeToTrip () {
      this.$channel.bind('trip', (data) => {
        if (data.Direction === null) return
        let message = this.$t('TRIP') + ' ' + data.TourName + this.$t('HASBEEN')
        let TripID = parseInt(data.TripID)
        if (data.IsClosed === 0) {
          if (data.Db_Date !== null && !EventBus.trips.ids.includes(TripID)) {
            EventBus.trips.ids.push(TripID)
            EventBus.trips.total++
            message += this.$t('CREATED')
          } else if (data.Db_Date === null) message += this.$t('DELAYED')
          else return
          this.getBusInfo(data, 'trip')
        } else {
          if (data.IsClosed !== 1) return
          if (EventBus.trips.total !== 0) EventBus.trips.total--
          EventBus.$emit('trip', data)
          message += data.IsCancelled === 1 ? this.$t('CANCELLED') : this.$t('CLOSED')
        }
        this.newTrip(message)
      })
    },
    latestIncidents () {
      return this.$http.get('/incident/latest?limit=5&offset=0')
    },
    latestMessages () {
      return this.$http.get('/message/latest?limit=5&offset=0')
    },
    latestViolations () {
      return this.$http.get('/violation/latest?limit=5&offset=0')
    },
    latestTrips () {
      return this.$http.get('/trip/onTransit?limit=5&offset=0')
    },
    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    },
    newMessage () {
      this.$message({
        message: this.$t('YOUHAVERECEIVEDANEWMESSAGE'),
        iconClass: 'fa fa-envelope'
      })
    },
    newTrip (message) {
      this.$message({
        message: message,
        iconClass: 'fa fa-bus'
      })
    },
    newIncident (data) {
      if (localStorage.getItem('notification') !== '1') return
      let self = this
      this.$notify({
        iconClass: 'fa fa-exclamation-triangle fa-2x icon-incident',
        title: self.$t('NEWINCIDENT'),
        message: data.Text,
        duration: 0,
        onClick: function () {
          self.showIncident(data)
          this.close()
        }
      })
    },
    newViolation (data) {
      if (localStorage.getItem('notification') !== '1') return
      this.$notify({
        iconClass: 'fa fa-tachometer fa-2x icon-violation',
        title: this.$t('NEWVIOLATION'),
        message: this.$t(data.Label),
        duration: 0
      })
    },
    showIncident (incident) {
      this.incident = incident
      this.incidentBox = true
    },
    logout () {
      let self = this
      this.$http.post('/user/logout', {lang: this.lang}).then(function (response) {
        self.clearSessionData()
      }).catch(function (response) {})
    },
    clearSessionData () {
      if (this.$route.name === 'ResetPassword') return
      this.$permissions = undefined
      this.$pusher.unsubscribe(localStorage.getItem('school_id'))
      delete Vue.prototype.channel
      let lang = localStorage.getItem('lang')
      localStorage.clear()
      this.$message({type: 'success', message: 'LOGINGOUT'})
      localStorage.setItem('lang', lang)
      userData = null
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push('/login')
    }
  }
}
</script>

<style>
  body{margin: 0;background: #e6e5e2;  font-family: "MavenProRegular", Arial, sans-serif;overflow: hidden}
  h1, h2,h3, h4,h5, h6{  font-family: "MavenProRegular", Arial, sans-serif;}
#app {
  color: #2c3e50;
  position: relative;
  height:100%
}
  .container{
  height:100%;
  padding-top: 53px;
    overflow: hidden;
    overflow-y: auto;

}
  .el-menu, body, html {
    height: 100% !important;
  }
  .el-menu, .el-card{
    border-radius: 0 !important;

  }

  .menu {
    height: 100% !important;
    text-align: left;
    background-color: #f5c93c;
    position: fixed;

  }
  .menu .el-menu-item, .menu .el-submenu__title {padding:0 10px !important;}

  header {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    padding: 0;
    z-index: 1;
    box-sizing: border-box;
    z-index: 999;
  }



  /*The Wrapper*/
  .my-scrollbar .el-menu{    background-color: #f5c93c !important;}

  /*The Content*/
  .scroll-me{
    width: 100%;
  }
  #logo{text-align: center;padding-top:25px}
  #logo img{width:100px;vertical-align: middle;}
el-menu-item.is-active
  .el-card{border:0}

  a{color: #20a0ff;; text-decoration: none}
  .box-card{padding: 0}

  .el-table{border:0 !important;}
  td{padding:5px 0}
  td a{color:#333333 !important; margin:0 5px}
  .filters{padding:10px;}
  .el-tabs{margin-bottom: 15px}
  .dark{    background: #4b4b4b; color:#fff; padding: 0 5px}
  .dark ul{background: none; color:#fff}
  .dark .el-menu--horizontal .el-menu-item {color:#fff; float:right}
  #rtl   .dark .el-menu--horizontal .el-menu-item { float:left}
  label.el-form-item__label{font-weight: bold}
  header ul{list-style: none; }
  header ul li{display: inline-block !important; font-size: 14px  !important; }
  .el-badge{margin-top:6px}
  .el-badge i{font-size: 22px}
  .badges{margin: 0; padding:0;float:right; display: inline-table}
  .badges .badge_icon .el-dropdown{margin-right:15px !important;}
  #app .badges .badge_icon .el-badge{margin-right:25px !important;}
#rtl .badges .badge_icon .el-dropdown{margin-left:15px !important;margin-right:0 !important;}
#rtl  #app .badges .badge_icon .el-badge{margin-left:25px !important;margin-right:0 !important;}
  .el-dropdown{color:#fff   !important; cursor: pointer}
  .el-dropdown-menu__item{min-width: 200px}
  .profile   .el-dropdown-menu__item{min-width:0 }
  .img-circle{border-radius: 50%;margin-right: 10px}
  .entry{ background: #080808 ; margin-left:10px }
  .entry .el-dropdown{padding:18px 15px}
 .badge_icon .el-dropdown{padding:12px 5px}
 .profile{float:right; padding-left: 5px}
 .profile .el-dropdown{padding:10px 0}
  #rtl .profile,  #rtl .badges{float:left}
  #rtl .profile {padding-right: 5px}
  .form{overflow: hidden}
  .el-card .el-tabs{border-width:0; border-top-width: 1px}
  .form .el-card{margin-bottom: 0 !important;}
  .form .el-tabs{margin:0  !important; border:0}
  .el-notification, .el-message{z-index:9999   !important;}
  .icon-bus{color:#f5c838}
  .icon-message{color:#b6b5b3}
  .icon-incident{color:#f4897c}
  .icon-violation{color:#f4dd93}
  .is-with-icon{padding-left:40px}
  .is-with-icon i{position:absolute !important; left:-12px !important; top:-10px !important;height:20px; width:20px; padding:10px; color:#fff; font-size: 20px}
  .is-with-icon i.fa-bus{ background: #f5c838;}
  .is-with-icon i.fa-envelope{ background: #b6b5b3;}
  .googleMap{margin:-15px}
  .el-dialog__footer{border-top:1px solid #ddd}
  .only-bottom-border input{border-width: 0; border-bottom-width: 1px; border-radius: 0}
  .only-top-border input{border-width: 0; border-top-width: 1px; border-radius: 0}
  .list{border-top:1px solid rgb(209, 219, 229); padding:5px; color:#333333 }
  .list a{color:#4b4b4b}
  .list:first-child{border:0}
  .googleMap{margin:-15px; margin-bottom:20px}
  .googleMap input{border-radius: 0; border-left:0; border-right:0}
    .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
 
 .el-message{z-index:9999 !important}
.el-tabs--border-card >.el-tabs__content {padding: 15px !important;}
img.rounded-img {
    border-radius: 50%;
    border: 4px solid #f5c838;
    -webkit-box-shadow: 0px 0px 142px -37px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 0px 142px -37px rgba(0,0,0,0.75);
    box-shadow: 0px 0px 142px -37px rgba(0,0,0,0.75);
}
.text-success{color:#13ce66 !important}
.text-danger {color: #d9534f !important}
.text-center{text-align:center !important}
table .fa{font-size:18px; line-height: 1; cursor:pointer}
table .el-button--text{color:#4b4b4b}
.el-progress-bar__outer {    background-color: #4b4b4b !important; color:#fff}
.el-button.btn-active{background-color: #4b4b4b; color:#fff}
.el-button.btn-active:hover{ color:#fff; border-color:#4b4b4b}
.morning.icon, .evening.icon {
  display: block;
  height: 50px;
  background-repeat: no-repeat;
  background-size:90%;
  background-position: center center;
}
.morning.icon {background-image: url('assets/img/submit-mrng.png')}
.evening.icon {background-image: url('assets/img/submit-evng.png')}
.morning.activated {background-image: url('assets/img/submit-mrng-sel.png')}
.evening.activated {background-image: url('assets/img/submit-evng-sel.png')}
.icon-v{
    background-image: url('assets/img/sprite.png');
    background-repeat: no-repeat;
    display: inline-block;
    margin-bottom:10px
}
.el-color-picker__trigger{padding:0 5px !important;    height: 36px !important;}
.el-color-picker__icon{margin-left:20px}
.el-tabs--border-card >.el-tabs__header {border:0 !important; }
.el-upload-list{display:none}
.el-notification__group.is-with-icon{margin-left:0 !important}
.el-table th > .cell {color:#fff}
 .el-year-table td.current:not(.disabled) .cell {color:#fff !important}
.trip-box.el-button--text{border-bottom:1px solid #ddd; width:100%;display:block; border-radius:0; margin:0 !important;}
 .trip-box:nth-child(2n) {background: #FAFAFA !important; }
 .trip-box .fa-home{font-size:39px; margin-top:-4px}
 .badges .el-button--text{color:#fff; padding:0}
  .sub-active, .activated.is-opened {background-color: #f4dd93;font-weight: 700;}
  .formTab .el-tabs__content{padding:0 !important;}
  .scrollbar  .el-form{padding:15px !important;}
  .avatar-uploader .el-upload{margin-bottom:10px}
  .avatar-uploader{margin-bottom:10px}
  .el-notification:hover{cursor:pointer}
  .filters .el-input .el-input__icon:hover {color: #ababab;cursor:pointer}  
  .el-button.el-tooltip.el-button--text {padding-top: 0;}
  @keyframes pulsate {
    0% {
        transform: scale(0.1);
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        transform: scale(1.2);
        opacity: 0;
    }
}
  .pulse {
    box-sizing:border-box;
    background: #346FF7;
    box-shadow: 2px 2px 4px #333;
    border:5px solid #346FF7;
    height: 15px;
    width: 15px;
    border-radius: 10px;
    animation: pulse 1500ms ease-out infinite;
}

@-webkit-keyframes pulse {
    40% {
        -webkit-transform: scale(2);
        -moz-transform: scale(2);
        transform: scale(2);
    }

    100% {
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        transform: scale(1);
    }
}
@-moz-keyframes pulse {
    40% {
        -webkit-transform: scale(2);
        -moz-transform: scale(2);
        transform: scale(2);
    }

    100% {
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        transform: scale(1);
    }
}
@keyframes pulse {
    40% {
        -webkit-transform: scale(2);
        -moz-transform: scale(2);
        transform: scale(2);
    }

    100% {
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        transform: scale(1);
    }
}
.bus{font-size:15px; color:#fff}
.el-card.card-border{border-width:0; border-left-width: 1px}
  button.list{border:0; border-bottom:1px solid rgb(209, 219, 229); padding:11px; width:100%;  text-align: left !important;margin:0 !important; border-radius: 0}
  button.list:first-child{border-bottom:1px solid rgb(209, 219, 229) !important;}
.list.active{background: rgb(209, 219, 229); font-weight:bold}
.filters .el-input .el-input__icon:hover {color: #ababab;cursor:pointer} 
 .el-button.el-tooltip.el-button--text {padding-top: 0;}
  .menu{ left: 0}
 #rtl .menu{right:0; left: auto}
#rtl .el-card.card-border {border-width:0; border-right-width: 1px}
button.list {text-align: left !important;}
#rtl button.list {text-align: right !important;}
#rtl input, #rtl .el-menu {text-align:right}
.el-pagination{text-align: right}
#rtl .el-pagination{text-align:left}
.el-card__header .el-dropdown, .el-card__header .el-button{float:right !important}
#rtl .el-card__header .el-dropdown, #rtl .el-card__header .el-button{float:left !important}
.img-circle{width:50px; float:left; margin-right:10px }
#rtl .img-circle{float:right; margin-left:10px; margin-right:0 }
.list .el-badge { float: right}
#rtl .list .el-badge { float: left}
#rtl .el-notification__group.is-with-icon{margin-right:0 !important}
#rtl .is-with-icon i{ right:-12px !important; left: auto !important}
#rtl   .is-with-icon{padding-right:40px; padding-left:0}
.adec-icon {width:32px; float:left}
#rtl .adec-icon {float:right}
#rtl #day-info{direction: rtl}
.profile .img-circle{margin-right:0; margin-left: 5px; float:right}
.profile-name { margin-top:5px !important; float:right}
#rtl .profile .img-circle {float:left; margin-right:5px ; margin-left: 0}
.form .el-card__header .el-button--primary{margin-left:5px}
#rtl .form .el-card__header .el-button--primary{margin-right:5px; margin-left:0}
.media .media-left {float: left;}
#rtl .media .media-left {float: right;}
.clearfix .el-dropdown .el-button-group {display: inline-flex;}
.busTag{text-align: left}
.boardingTag{text-align: right}
#rtl .boardingTag {text-align: left}
#rtl .busTag {text-align: right}
#rtl .is-center .cell{ text-align: center}
.ps-container .scroll-border {border-right:1px solid rgb(204, 204, 204);}
#rtl .ps-container .scroll-border {border-left:1px solid rgb(204, 204, 204);}
.el-checkbox-button__inner{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;outline:0;text-align:center}
.el-checkbox-button,.el-checkbox-button__inner{position:relative;display:inline-block}
.el-checkbox__label{font-size:14px;padding-left:5px}
.el-checkbox-button.is-checked .el-checkbox-button__inner{color:#fff;background-color:#4b4b4b;border-color:#4b4b4b;box-shadow:-1px 0 0 0 rgb(204, 204, 204) !important}
.el-checkbox-button.is-disabled .el-checkbox-button__inner{color:#bfcbd9;cursor:not-allowed;background-image:none;background-color:#eef1f6;border-color:#d1dbe5;box-shadow:none}
.el-checkbox-button__inner,.el-transfer-panel{background:#fff;vertical-align:middle;box-sizing:border-box}
.el-checkbox-button.is-focus .el-checkbox-button__inner{border-color:#4b4b4b}

.el-checkbox-button:first-child .el-checkbox-button__inner{border-left:1px solid #bfcbd9;border-radius:4px 0 0 4px;box-shadow:none!important}
.el-checkbox-button:first-child:last-child .el-checkbox-button__inner {border-bottom-left-radius: 4px;border-top-left-radius: 4px;}
.el-checkbox-button:last-child .el-checkbox-button__inner{border-radius:0 4px 4px 0}
#rtl .el-checkbox-button.is-checked .el-checkbox-button__inner{box-shadow:1px 0 0 0 rgb(204, 204, 204) !important}
#rtl .el-checkbox-button:first-child .el-checkbox-button__inner {border-radius:0 4px 4px 0;border-left:0; border-right:1px solid #bfcbd9;}
#rtl .el-checkbox-button:first-child:last-child .el-checkbox-button__inner {border-radius:4px}
#rtl .el-checkbox-button:last-child .el-checkbox-button__inner{border-radius:4px 0 0 4px;  border-left:1px solid #bfcbd9;}

.el-checkbox-button__inner{line-height:1;white-space:nowrap;border:1px solid #bfcbd9;border-left:0;color:#1f2d3d;margin:0;cursor:pointer;transition:all .3s cubic-bezier(.645,.045,.355,1);padding:10px 15px;font-size:14px;border-radius:0}.el-checkbox-button__inner:hover{color:#4b4b4b}.el-checkbox-button__inner [class*=el-icon-]{line-height:.9}
.el-checkbox-button__inner [class*=el-icon-]+span{margin-left:5px}
.el-checkbox-button__original{opacity:0;outline:0;position:absolute;margin:0;visibility:hidden;left:-999px}
.el-checkbox-button--large .el-checkbox-button__inner{padding:11px 19px;font-size:16px;border-radius:0}
.el-checkbox-button--small .el-checkbox-button__inner{padding:7px 9px;font-size:12px;border-radius:0}
.el-checkbox-button--mini { padding:4px;font-size:12px;border-radius:0}
.border1, .border2{border-right:1px solid rgb(209, 219, 229)}
#rtl .border1, #rtl .border2{border-left:1px solid rgb(209, 219, 229);border-right:0}
.border1 .fa-bus{float: left;margin-right:10px}
#rtl .border1 .fa-bus{float: right;margin-right:0;margin-left:10px}
.staff .el-button{float:right}
#rtl .staff .el-button{float:left}
#tripMng .border1 .fa{float: left;margin-right:10px}
#rtl #tripMng .border1 .fa{float: right;margin-left:10px}
#tripMng .list span {float:left; padding-right:5px}
#rtl #tripMng .list span {float:right; padding-left:5px}
#tripMng .el-button-group.turn, #tripMng .el-button-group.turn + .el-button--danger {float:right}
#rtl #tripMng .el-button-group.turn, #rtl #tripMng .el-button-group.turn + .el-button--danger {float:left}
#rtl .fa.fa-chevron-left, #rtl .morning.icon, #rtl .evening.icon, #rtl .fa.fa-chevron-right{
   -webkit-transform:rotateY(180deg);
   -moz-transform:rotateY(180deg);
   -o-transform:rotateY(180deg);
   -ms-transform:rotateY(180deg);  
}
#rtl .ps__scrollbar-y-rail{ right: 0.2rem; }
#rtl .ps__scrollbar-x-rail{ display: none; }
.el-message-box__headerbtn, .el-dialog__headerbtn{background: none;border: 0;}
.red-color{color: red}
.blue-color{color: blue}
.pull-right, #rtl .pull-left {float: right;}
.pull, #rtl .pull-right {float: left;}
.media-heading .pull-right:hover {color: #ababab;cursor:pointer}
.tab-table-margin {margin-right:-15px;margin-left:0}
#rtl .tab-table-margin {margin-left:-15px;margin-right:0}
.el-form-item.is-required .el-form-item__label:before{font-size: 18px;}
.el-carousel {overflow: hidden;}
.hide-arrow .el-submenu__icon-arrow, .activated .el-submenu__icon-arrow{display: none}
.menu ::-webkit-scrollbar{background:  transparent}
.el-select-dropdown__item span:first-child{float: left}
#rtl .el-select-dropdown__item span:first-child{float: right}
.el-select-dropdown__item span:nth-child(2){float: right}
#rtl .el-select-dropdown__item span:nth-child(2){float: left}
.el-button.trip-box.is-disabled:hover{cursor: pointer}
</style>



// WEBPACK FOOTER //
// App.vue?ec87daa0